module.exports = __webpack_public_path__ + "img/partner1.4f33ba26.jpg";